import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader } from "../Helpers";
import { STR_BUSINESS_NAME, STR_BUSINESS_TYPE, STR_COMPANY, STR_CONTACT_US, STR_GET_FREE_TRIAL, STR_INVALID_BUSINESS_NAME, STR_OPTIONAL, STR_REGISTER_BUSINESS, STR_SOLE_PROPRIETOR, STR_SUBMIT, STR_SUCCESS, STR_WEBSITE_URL } from "../Strings";
import MobileInterface from "../MobileInterface";

import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { MdCall, MdEmail } from "react-icons/md";


export default function ContactUs(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [name, setName] = useState('');
	const [businessType, setBusinessType] = useState('company');
	const [websiteUrl, setWebsiteUrl] = useState('');

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	async function submit() {
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'register-business',
				{
					name,
					businessType,
					websiteUrl,
				}
			).then(async (response) => {
				if(response.status === 1) {
					appContext.tellMessage(STR_SUCCESS[appContext.language]);
					await appContext.getCurrentUserData().then(_userData => {
						if(_userData && _userData.businesses && _userData.businesses.length > 0) {
							appContext.setCurrentBusiness(_userData.businesses[_userData.businesses.length - 1]);
							appContext.navBack();
						} else {
							//keep currentBusiness unselected
						}
					})
				} else {
					appContext.tellError(response.msg)
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_INVALID_BUSINESS_NAME[appContext.language]);
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<h6 className="main-section-title">
								{STR_REGISTER_BUSINESS[appContext.language]}
							</h6>
						</div>

						<div className="col-md-12">
							<div className="card">
								<div className="card-body">
									<h6
										style={{
											fontSize: "24px"
										}}
										className="font-light text-center text-primary"
									>
										{STR_GET_FREE_TRIAL[appContext.language]}
									</h6>
								</div>
							</div>
						</div>

						<div className="col-md-12 mt-3 mb-3">
							<label className="form-label">{STR_BUSINESS_NAME[appContext.language]}</label>
							<input
								className="form-control"
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
						</div>

						<div className="col-md-12 mt-3 mb-3">
							<label className="form-label">{STR_BUSINESS_TYPE[appContext.language]}</label>
							<div className="row">
								<div className="col-6">
									<button
										className={(businessType === 'company') ? "btn btn-primary btn-block" : "btn btn-outline-primary btn-block"}
										style={{
											height: "70px",
										}}
										onClick={() => setBusinessType('company')}
									>
										{STR_COMPANY[appContext.language]}
									</button>
								</div>

								<div className="col-6">
									<button
										className={(businessType === 'individual') ? "btn btn-primary btn-block" : "btn btn-outline-primary btn-block"}
										style={{
											height: "70px",
										}}
										onClick={() => setBusinessType('individual')}
									>
										{STR_SOLE_PROPRIETOR[appContext.language]}
									</button>
								</div>
							</div>
						</div>

						<div className="col-md-12 mt-3 mb-3">
							<label className="form-label">{STR_WEBSITE_URL[appContext.language]}</label>
							<input
								className="form-control"
								value={websiteUrl}
								onChange={(e) => setWebsiteUrl(e.target.value)}
							/>
							<div className="form-text">
								{STR_OPTIONAL[appContext.language]}
							</div>
						</div>

						<div className="col-md-12 mt-3 mb-5">
							<button
								className="btn btn-block btn-padded btn-rounded btn-secondary"
								onClick={submit}
							>
								{STR_SUBMIT[appContext.language]}
							</button>
						</div>

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}